<template>
  <div>
    <div class="card shadow mb-3">
      <div class="card-header">
        Mailing List
      </div>
      <div class="card-body" v-loading="loading">
        <subscriber-chart />
      </div>
    </div>
    <div class="card shadow">
      <div class="card-header">
        Recent Subscribers
      </div>
      <div v-loading="loading">
        <table class="table">
          <thead class="thead-light">
            <tr>
              <th>Name</th>
              <th>Email Address</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="subscriber in subscribers" :key="subscriber.id">
              <td>
                {{ subscriber.name }}
                <span v-if="subscriber.user" class="badge badge-pill badge-primary">User</span>
                <span v-if="subscriber.recipe" class="badge badge-pill badge-warning">PDF</span>
              </td>
              <td>{{ subscriber.email }}</td>
              <td>{{ subscriber.createdAt }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import SubscriberChart from '@/components/Subscriber/SubscriberChart'

export default {
  data() {
    return {
      loading: true,
      subscribers: [],
    }
  },

  components: {
    SubscriberChart,
  },

  mounted() {
    this.getSubscribers()
  },

  methods: {
    getDate(date) {
      return moment(date).fromNow()
    },

    async getSubscribers() {
      try {
        var { data } = await this.$http.get(`/subscribers`, {
          params: { offset: 0, limit: 50 },
        })
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }

      this.subscribers = data.map(item => {
        item.createdAt = moment(item.createdAt).fromNow()
        return item
      })
    },
  },
}
</script>
